export const RAPORBULANAN_GET = 'RAPORBULANAN_GET';
export const RAPORBULANANDETAIL_GET = 'RAPORBULANANDETAIL_GET';